export const isTouchDevice = (): boolean => 'ontouchstart' in global || navigator.maxTouchPoints > 0;
